import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Artifact, DBDef_Artifact } from '@app/org-shared';
export const dispatch_onArtifactsUpdated = new ThunderDispatcherV3('__onArtifactsUpdated');
export class ModuleFE_Artifact_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_Artifact, dispatch_onArtifactsUpdated);
        this._v1 = {
            'get-artifact-data-by-facility': apiWithBody(ApiDef_Artifact._v1['get-artifact-data-by-facility']),
            'register-version': apiWithBody(ApiDef_Artifact._v1['register-version']),
            'get-artifact-backup-path': apiWithBody(ApiDef_Artifact._v1['get-artifact-backup-path']),
            'get-artifact-data-by-version': apiWithBody(ApiDef_Artifact._v1['get-artifact-data-by-version']),
            'check-version-exists': apiWithBody(ApiDef_Artifact._v1['check-version-exists']),
            'trigger-artifact-pipeline': apiWithBody(ApiDef_Artifact._v1['trigger-artifact-pipeline']),
            //Don't add anything under this, it'll be affected by the ts-ignore.
            // @ts-ignore // to be used only by advisor.
            'getAdvisorSnapshotArtifactMetadata': undefined,
        };
    }
}
export const ModuleFE_Artifact = new ModuleFE_Artifact_Class();
//# sourceMappingURL=ModuleFE_Artifact.js.map